<template>
  <div class="image-preview" v-loading="loading">
    <viewer
      id="image-container"
      :images="images"
      @inited="viewInit"
      class="viewer"
      ref="viewer">
      <img v-for="src in images" :src="src" :key="src" v-show="false" alt="/">
    </viewer>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import { component as Viewer } from "v-viewer";
import common from "@/mixins/common";
import { EventBus } from "@/utils/eventBus";

export default {
  name: "image-preview",
  mixins: [common],
  components: {
    Viewer
  },
  data() {
    return {
      images: []
    }
  },
  async mounted() {
    const res = await this.getBlobData();
    if (res) {
      const file = new FileReader();
      file.readAsDataURL(res.data);
      file.onload = (e) => {
        console.log('e', e);
        this.images = [e.target.result];
        this.show();
      }
    }
  },
  methods: {
    // async getData() {
    //   const res = await this.$http.get(this.previewData.fileUrl, {
    //     responseType: 'blob'
    //   });
    //   console.log('res', res);
    //   const file = new FileReader();
    //   file.readAsDataURL(res.data);
    //   file.onload = (e) => {
    //     console.log('e', e);
    //     this.images = [e.target.result];
    //     this.show();
    //   }
    // },
    viewInit (viewer) {
      this.$viewer = viewer;
      const _el = document.getElementById('image-container');
      _el.addEventListener('hidden', () => {
        EventBus.$emit('close');
      }, false);
    },
    show () {
      this.$viewer.show();
    },
  }
}
</script>

<style scoped>

</style>
